import { React, FormControl, Select, MenuItem, SelectChangeEvent, FormControlProps, Typography } from '../../utils/globalImports';
import EllipsisWithConditionalTooltip from './EllipsisWithConditionalTooltip';
interface Option {
  value: string | number; // The value for the dropdown option
  text: string;           // The display text for the dropdown option
}

interface CustomDropdownProps {
  value: string | number; // The current selected value
  onChange: (event: SelectChangeEvent<string | number>) => void; // Callback function for value change
  sx?: object; // Allow custom styling
  label: string;                // The label text for the dropdown
  options?: Option[];           // Optional: Array of options (default: ['Active', 'InActive', 'Both'])
  formControlProps?: FormControlProps;   // Optional: Props for FormControl component
  requiredLabel?: boolean;
  required?: boolean;
  disable?: boolean;
  disableSorting?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  value,
  onChange,
  sx,
  label,
  options = [
    { value: 1, text: 'Active' },
    { value: 0, text: 'Inactive' },
  ], // Default options if not provided
  formControlProps,
  requiredLabel = false,
  required = true,
  disable,
  disableSorting=false
}) => {
   /** ✅ SORT ONLY IF disableSorting IS FALSE */
  const sortedOptions = disableSorting
    ? options
    : options.slice().sort((a, b) => a.text.localeCompare(b.text));
  return (
    <FormControl fullWidth {...formControlProps}>

      {requiredLabel && (
        <Typography variant="subtitle1" sx={{ display: 'block', color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1 }}>
          {label}
          {required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      )}

      {/* <InputLabel {...inputLabelProps}>{label}</InputLabel> */}
      <Select
        value={value}
        onChange={onChange}
        disabled={disable}
        // label={label}
        sx={{
          ...sx,
          borderRadius: '20px', // Rounded corners for the dropdown
          '& .MuiSelect-select': {
            padding: '10px 15px', // Padding for the dropdown value (selected item)
            fontSize: '14px', // Font size for the selected item
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200, // Set maximum height for the dropdown menu
              maxWidth: 200, // Set maximum width for the dropdown menu
            },
          },
        }}
      >
        <MenuItem value="-1">
          {label}
        </MenuItem>
        {sortedOptions.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            <EllipsisWithConditionalTooltip>
              {option.text}
            </EllipsisWithConditionalTooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdown;